module.exports = __webpack_public_path__ + "static/media/19ESCAP16.cef0e3c2.jpg";